export default "__VITE_ASSET__CaSw8Hqh__"